import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts';
import { Loader2 } from 'lucide-react';

/**
 * Investor Route Guard
 * Only allows access to users with 'investor' or 'both' role
 * Redirects to /login if not authenticated
 * Redirects to /unauthorized if authenticated but not an investor
 */
export const InvestorRoute = ({ children }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has investor access (role = 'investor' or 'both')
  const hasInvestorAccess = user?.user_role === 'investor' || user?.user_role === 'both';

  // Redirect to unauthorized if not an investor
  if (!hasInvestorAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Render children if all checks pass
  return children;
};

export default InvestorRoute;
